import { FunctionComponent } from 'react';
import Link from 'next/link';

import { Routes } from 'types/routes';

import { withVariables } from 'utils/string';

import StyledComponent from './styles';
import { Props } from './types';

const PublicLayoutBlogsArticleCategoriesList: FunctionComponent<Props> = ({ categories }) => {
    if (!Array.isArray(categories) || !categories.length) return null;

    return (
        <StyledComponent className="public-layout-blogs-article-categories-list">
            {categories.map(category => {
                return (
                    <Link
                        key={category?.id}
                        href={withVariables(Routes.PublicBlogCategory, { articleCategorySlug: category?.locale?.slug })}
                        prefetch={false}
                    >
                        <div
                            className="category"
                            key={category?.id}
                        >
                            <div
                                className="category-title"
                                dangerouslySetInnerHTML={{ __html: category?.locale?.name }}
                            />
                            <span className="dot">•</span>
                        </div>
                    </Link>
                );
            })}
        </StyledComponent>
    );
};

export default PublicLayoutBlogsArticleCategoriesList;